<template>
  <div>
    <h1>Choose what data to export</h1><br>
    <el-checkbox-group v-model="exportFields">
      <el-checkbox v-for="field in fieldOptions" :key="field.value" :label="field.value" class="field">{{ field.label }}</el-checkbox>
    </el-checkbox-group><br>
    <el-button type="primary" icon="el-icon-document" @click="exportReport">Export</el-button>
  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    reports: {},
    reportType: null
  },
  data () {
    return {
      exportFields: ['id', 'urgency', 'peaName', 'creatorName', 'peaDepartments', 'peaDivision', 'peaStatus', 'reason', 'costCenter', 'costToDate', 'netExpenditure', 'approvedDate', 'projectEndDate'],
      fieldOptions: [
        { label: 'PEA Id', value: 'id' },
        { label: 'Emergency', value: 'urgency' },
        { label: 'PEA Name', value: 'peaName' },
        { label: 'Creator Name', value: 'creatorName' },
        { label: 'Departments', value: 'peaDepartments' },
        { label: 'Division', value: 'peaDivision' },
        { label: 'Status', value: 'peaStatus' },
        { label: 'Reason', value: 'reason' },
        { label: 'Cost Center', value: 'costCenter' },
        { label: 'Cost to Date', value: 'costToDate' },
        { label: 'Estimated Cost', value: 'netExpenditure' },
        { label: 'Approved Date', value: 'approvedDate' },
        { label: 'Project End Date', value: 'projectEndDate' }
      ],
      csvData: ''
    }
  },
  computed: {
    titleRow () {
      var fields = this.exportFields.map(field => {
        var selectedField = this.fieldOptions.filter(option => {
          return field === option.value
        })
        return selectedField[0].label
      })
      return fields.join(',')
    },
    reportDetails () {
      if (typeof this.reportType === 'object') {
        return this.reportType.join(',')
      } else {
        return this.reportType
      }
    }
  },
  methods: {
    exportReport () {
      let csvContent = ''
      let headerinfo = 'data:text/csv;charset=utf-8,'
      csvContent += this.titleRow + '\r\n'
      let csvData = this.appendPEAs(this.reports)
      csvContent += csvData
      this.csvData = ''
      if (navigator.msSaveBlob) { // IE 10+
        var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        navigator.msSaveBlob(blob, 'PEAs by ' + this.reportDetails + '.csv')
      } else {
        csvContent = headerinfo + csvContent
        var encodeUri = encodeURI(csvContent)
        var link = document.createElement('a')
        link.setAttribute('href', encodeUri)
        link.setAttribute('download', 'PEAs by ' + this.reportDetails + '.csv')
        document.body.appendChild(link)
        link.click()
      }
    },
    appendPEAs: function (group) {
      let row = ''

      if (group.peas) {
        group.peas.forEach(pea => {
          row = ''
          this.exportFields.forEach(field => {
            if (typeof pea[field] === 'object') {
              if (pea[field]) {
                var array = []
                pea[field].forEach(obj => {
                  var replace = obj.name.toString().replace(/–/g, '-')
                  replace = replace.toString().replace(/#/g, ' ')
                  replace = replace.toString().replace(/,/g, ' ')
                  if (replace.split('"').length - 1 > 0) {
                    array.push('"' + replace)
                  } else {
                    array.push('"' + replace + '"')
                  }
                })
                row += array.join(';')
              } else {
                row += ''
              }
            } else if (field === 'urgency') {
              row += pea[field] ? 'Yes' : 'No'
            } else if (field === 'creatorName') {
              row += String(pea[field]).split(',').reverse().join(' ')
            } else if (field === 'approvedDate') {
              let date = this.formatDate(pea[field])
              row += date.split(',').join(' ')
            } else if (field === 'netExpenditure' || field === 'costToDate') {
              row += '$' + this.formatMoney(pea[field]).split(',').join('')
            } else if (field === 'projectEndDate') {
              let date = this.formatDate(pea[field])
              row += date.split(',').join(' ')
            } else {
              var replace2 = pea[field].toString().replace(/–/g, '-')
              replace2 = replace2.toString().replace(/#/g, ' ')
              replace2 = replace2.toString().replace(/,/g, ' ')
              if (replace2.split('"').length - 1 > 0) {
                row += '"' + replace2
              } else {
                row += '"' + replace2 + '"'
              }
            }
            row += ','
          })
          this.csvData += row + '\r\n'
        })
      }

      if (group.groups) {
        group.groups.forEach(subGroup => {
          this.appendPEAs(subGroup)
        })
      }
      return this.csvData
    },
    formatMoney: function (money) {
      return helperMethods.formatMoney(parseFloat(money))
    },
    formatDate: function (date) {
      return helperMethods.formatDate(helperMethods.convertDatetoISO(date))
    }
  }
}
</script>

<style lang="css" scoped>
  h1 {
    font-size: 2em;
  }

  .el-checkbox {
    width: 42%;
    text-align: left;
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0;
  }
</style>

<style lang="css">
  .field .el-checkbox__input {
    float: left;
    margin-right: 7px;
    top: 2px;
  }

  .field .el-checkbox__label {
    float: none;
    display: block;
  }
</style>
